import { render, staticRenderFns } from "./AddNewSupplier.vue?vue&type=template&id=90f7ffa6&scoped=true"
import script from "./AddNewSupplier.vue?vue&type=script&lang=js"
export * from "./AddNewSupplier.vue?vue&type=script&lang=js"
import style0 from "./AddNewSupplier.vue?vue&type=style&index=0&id=90f7ffa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f7ffa6",
  null
  
)

export default component.exports